// extracted by mini-css-extract-plugin
export default {"cancelButton":"AddOrganization_cancelButton__dBUy+"};